import TemplateView from "../../TemplateView";
import StatusesSectionWrapper from "./StatusesSectionWrapper";
import messageResource from "../../messageResource"
import EditWorkflowStatusDialog from "./EditWorkflowStatusDialog";
import SelectColorContent from "./SelectColorContent";
import DialogFooter from "./DialogFooter"
import {WorkflowStatusType} from "../../workflowStatus/constants";
import {
    addNewStatusAction,
    changeWorkflowStatusPosition,
    createOrEditWorkflowStatus,
    deleteWorkflowStatus,
    updateEditingStatusColorIdAction,
    startEditStatusAction,
    updateEditingStatusNameAction,
    cancelEditOrCreateStatusAction
} from "./actions"
import {
    isLoading,
    getPageStatuses,
    getErrors,
    getEditDialogData,
    isShowEditStatusDialog,
} from './selectors'
import EditWorkflowStatusDialogWrapper from "./EditWorkflowStatusDialogWrapper";
import {ValidationErrors, NEW_STATUS_ID} from "./constants";
import LoadingContainer from "../../util/LoadingContainer";
import InfoContent from "./InfoContent";
import LoadingSpinner from "../../components/LoadingSpinner";
import StatusesListContainer from "./StatusesListContainer";
import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'

export class PageContent extends TemplateView {

    constructor({
        addNewStatusAction,
        changeWorkflowStatusPosition,
        createOrEditWorkflowStatus,
        deleteWorkflowStatus,
        updateEditingStatusColorIdAction,
        startEditStatusAction,
        updateEditingStatusNameAction,
        cancelEditOrCreateStatusAction
    }) {
        super(null)

        this.state = {
            loading: false,
            statuses: [],
            showEditStatusDialog: false,
            editingStatus: {
                id: null,
                name: '',
                colorId: -1,
            },
            errors: []
        }
        this.actions = {
            addNewStatusAction,
            changeWorkflowStatusPosition,
            createOrEditWorkflowStatus,
            deleteWorkflowStatus,
            updateEditingStatusNameAction,
            updateEditingStatusColorIdAction,
            startEditStatusAction,
            cancelEditOrCreateStatusAction,
        }

        this.onStatePropertyChanged('loading', loading => {
            this.loadingSpinner.setState({show: loading})
            this.editWorkflowStatusDialog.setState({loading: loading})
            this.statusesSection.setState({loading: loading})
        })

        this.onStatePropertyChanged('showEditStatusDialog', showEditStatusDialog => {
            if (!showEditStatusDialog)
                this.editWorkflowStatusDialog.hide()
        })

        this.onStatePropertyChanged('statuses', statuses => {
            this.openStatusesList.setState({
                statuses: statuses.filter(s => s.type === WorkflowStatusType.OPEN),
            })
            this.completedStatusesList.setState({
                statuses: statuses.filter(s => s.type === WorkflowStatusType.COMPLETED),
            })
        })

        this.onStatePropertyDeeplyChanged('editingStatus', () => {
            this.editWorkflowStatusDialog.setState({
                statusName: this.state.editingStatus.name,
                errors: this.state.errors
            })

            this.openStatusesSection.setState({
                newStatusInEdit: this.state.editingStatus.id === NEW_STATUS_ID && this.state.editingStatus.type === WorkflowStatusType.OPEN
            })
            this.completedStatusesSection.setState({
                newStatusInEdit: this.state.editingStatus.id === NEW_STATUS_ID && this.state.editingStatus.type === WorkflowStatusType.COMPLETED
            })
            this.openStatusesList.setState({editItemId: this.state.editingStatus.id})
            this.completedStatusesList.setState({editItemId: this.state.editingStatus.id})
            this.selectColorDialog.setState({selectedColorId: this.state.editingStatus.colorId})
        })

        this.onStatePropertyChanged('errors', errors => {
            this.editWorkflowStatusDialog.setState({errors: errors})
            this._handleErrors()
        })
    }

    templateHtml() {
        return '<div class="page">' +
               '    <div class="header">' +
               '        <div class="pagetitle"><%-pageTitle%></div>' +
               '    </div>' +
               '    <div class="pageContent">' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            pageTitle: "workflow_settings.page_title"
        }
    }

    afterRender() {
        this.loadingSpinner = new LoadingSpinner({
            config: {
                radius: 8,
                length: 5
            },
            delay: 500
        }).init(this.find('.header'))

        new InfoContent().init(this.find('.pageContent'))

        this.selectColorDialog = new SelectColorContent({
            onSelectColorCb: (colorId) => this.actions.updateEditingStatusColorIdAction(colorId)
        })

        const dialog = new EditWorkflowStatusDialog({
            selectColorContent: this.selectColorDialog,
            dialogFooter: new DialogFooter({
                submitBtnLabel: messageResource.getMessage('common.apply'),
                cancelBtnLabel: messageResource.getMessage('common.cancel'),
                onSubmitCb: () => {
                    this.actions.createOrEditWorkflowStatus();
                },
                onCancelCb: () => {
                    this.editWorkflowStatusDialog.hide()
                }
            }),
            onNameChangedCb: (name) => this.actions.updateEditingStatusNameAction(name)
        })

        this.editWorkflowStatusDialog = new EditWorkflowStatusDialogWrapper(null, {
            className: 'editWorkflowStatusDialogWrapper',
            dialog: new LoadingContainer({
                contentComponent: dialog,
                containerClass: 'editWorkflowStatusDialogLoadingContainer'
            }),
            preventHide: () => this.state.loading,
            onHide: () => {
                this.actions.cancelEditOrCreateStatusAction()
            }
        }).init(this.getEl())

        this.openStatusesList = new StatusesListContainer({
            onPositionChangedCb: this.actions.changeWorkflowStatusPosition,
            onStatusNameClickCb: ($el, id) => {
                this.actions.startEditStatusAction(id)
                this.editWorkflowStatusDialog.showAt($el)
            },
            onItemDeleteClickCb: this._handleDeleteStatusClick
        })

        this.openStatusesSection = new StatusesSectionWrapper({
            title: messageResource.getMessage("workflow_settings.open_tasks_statuses_section.title"),
            listContainer: this.openStatusesList,
            onAddBtnClickCb: ($el) => {
                this._handleAddNewStatusClick(WorkflowStatusType.OPEN)
                this.editWorkflowStatusDialog.showAt($el)
            }
        })

        this.completedStatusesList = new StatusesListContainer({
            onPositionChangedCb: this.actions.changeWorkflowStatusPosition,
            onStatusNameClickCb: ($el, id) => {
                this.actions.startEditStatusAction(id)
                this.editWorkflowStatusDialog.showAt($el)
            },
            onItemDeleteClickCb: (id) => this.actions.deleteWorkflowStatus(id)
        })

        this.completedStatusesSection = new StatusesSectionWrapper({
            title: messageResource.getMessage("workflow_settings.completed_tasks_statuses_section.title"),
            listContainer: this.completedStatusesList,
            onAddBtnClickCb: ($el) => {
                this._handleAddNewStatusClick(WorkflowStatusType.COMPLETED)
                this.editWorkflowStatusDialog.showAt($el)
            }
        })

        this.statusesSection = new LoadingContainer({
            contentComponent: [this.openStatusesSection, this.completedStatusesSection],
            containerClass: 'workflowStatusesSection',
            loadingMoireConfig: {
                delay: 500
            }
        }).init(this.find('.pageContent'))
    }

    _handleDeleteStatusClick = (id) => {
        this.actions.deleteWorkflowStatus(id)
    }

    _handleAddNewStatusClick = (type) => {
        this.actions.addNewStatusAction(type)
    }

    _handleErrors() {
        this.state.errors.forEach(error => {
            if (error === ValidationErrors.STATUS_DELETED) {
                alert(messageResource.getMessage('workflow_settings.errors.status_deleted'))
            }

            if (error === ValidationErrors.STATUS_IN_USE) {
                alert(messageResource.getMessage('workflow_settings.errors.status_in_use'))
            }

            if (error === ValidationErrors.STATUS_IS_LAST) {
                alert(messageResource.getMessage('workflow_settings.errors.status_is_last'))
            }
        })
    }
}

export default connect(
    (state) => ({
        loading: isLoading(state),
        statuses: getPageStatuses(state),
        showEditStatusDialog: isShowEditStatusDialog(state),
        editingStatus: getEditDialogData(state),
        errors: getErrors(state),
    }),
    (dispatch) => ({
        addNewStatusAction: bindActionCreators(addNewStatusAction, dispatch),
        changeWorkflowStatusPosition: bindActionCreators(changeWorkflowStatusPosition, dispatch),
        createOrEditWorkflowStatus: bindActionCreators(createOrEditWorkflowStatus, dispatch),
        deleteWorkflowStatus: bindActionCreators(deleteWorkflowStatus, dispatch),
        updateEditingStatusColorIdAction: bindActionCreators(updateEditingStatusColorIdAction, dispatch),
        startEditStatusAction: bindActionCreators(startEditStatusAction, dispatch),
        updateEditingStatusNameAction: bindActionCreators(updateEditingStatusNameAction, dispatch),
        cancelEditOrCreateStatusAction: bindActionCreators(cancelEditOrCreateStatusAction, dispatch),
    })
)(PageContent)



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/PageContent.js